export default __webpack_public_path__ + "static/06-e6441030507f7e2bcf5fe5204df2c713.jpg";